import Language from "../../Helpers/Language";

export default class DateTime {
    static humanReadable(date) {
        return new Date(date).toLocaleTimeString(
            Language.getLanguage() ?? null,
            {hour: "numeric", minute: "numeric"}
        );
    }

    static schedulePeriodHumanReadable(schedule) {
        const startHour = this.humanReadable(schedule['start']);
        const endHour = this.humanReadable(schedule['end']);

        return Language.isPortuguese() ? `${startHour}h às ${endHour}h` : `${startHour} to ${endHour}`
    }
}
